import styled from "styled-components";

export const HomeV2Style = styled.div`
  width: 100%;
  background: #0B0F1B;
  min-height: 100vh;
  color: #ffffff;
  padding-bottom: 60px;

  /* Hero Section */
  .hero-section {
    position: relative;
    width: 100%;
    height: 280px; /* reduced height */
    background: linear-gradient(
      135deg,
      rgba(138, 43, 226, 0.3) 0%,
      rgba(255, 20, 147, 0.3) 100%
    );
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 60px;
    margin-bottom: 24px;
  }

  .hero-bg-image {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(0.45) saturate(0.8);
    z-index: 0;
    pointer-events: none;
    border-bottom-right-radius: 14px;
  }

  .hero-overlay {
    width: 100%;
    max-width: 1400px;
    position: relative;
    z-index: 2;
  }

  .hero-content {
    max-width: 700px;
    position: relative;
    z-index: 3;
  }

  .hero-tag {
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 20px;
    text-transform: uppercase;
    letter-spacing: 2px;
  }

  .hero-title {
    font-size: 34px;
    line-height: 1.2;
    margin-bottom: 12px;
    color: #ffffff;
    text-transform: uppercase;
  }

  .hero-title-bold {
    font-weight: 700;
  }

  .hero-highlight {
    color: #007AFE;
  }

  .hero-welcome {
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 24px;
    margin-top: 0;
    letter-spacing: 0.5px;
  }

  .hero-subtitle {
    font-size: 13px;
    color: #b8b8b8;
    margin-bottom: 30px;
    line-height: 1.6;
  }

  .hero-buttons-container {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .hero-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    background: #007aff;
    padding: 0px 28px;
    height: 46px;

    font-family: Poppins;
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: -0.01em;
    text-align: center;
    border-radius: 23px;
    border: none;
    color: #fff;

    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 12px rgba(0, 122, 255, 0.3);

    @media (max-width: 1600px) {
      padding: 0px 20px;
      height: 42px;
      font-size: 13px;
    }

    @media (max-width: 1400px) {
      padding: 0px 14px;
      height: 34px;
      font-size: 12px;
    }

    @media (max-width: 1024px) {
      padding: 0px 16px;
      height: 36px;
      font-size: 12px;
    }

    &:hover {
      background: #0056cc;
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 122, 255, 0.4);
    }

    &:active {
      transform: translateY(0px);
      box-shadow: 0 2px 8px rgba(0, 122, 255, 0.25);
    }

    &.import-button {
      background: linear-gradient(135deg, #677BE6 0%, #754DA5 100%);
      box-shadow: 0 2px 12px rgba(103, 123, 230, 0.3);

      &:hover {
        background: linear-gradient(135deg, #5869d4 0%, #643d8f 100%);
        box-shadow: 0 6px 20px rgba(103, 123, 230, 0.4);
      }

      &:active {
        box-shadow: 0 2px 8px rgba(103, 123, 230, 0.25);
      }
    }
  }

  .hero-button svg{
    margin-right: 10px;
    width: 16px;
    height: 16px;

    @media (max-width: 1024px) {
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }
  }

  /* Best Albums Section */
  .best-albums-section {
    padding: 0 0px 0px 20px;
    margin-bottom: 24px;
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }

  .section-title-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .section-title {
    font-size: 28px;
    font-weight: 600;
    color: #ffffff;
  }

  .playlist-count-badge {
    background: #ffffff;
    color: #0B0F1B;
    font-size: 14px;
    font-weight: 700;
    padding: 4px 12px;
    border-radius: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 28px;
    height: 28px;
  }

  .navigation-buttons {
    display: flex;
    gap: 10px;
    margin-right: 20px;
  }

  .nav-button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: #ffffff;
    font-size: 24px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: rgba(92, 123, 246, 0.3);
      border-color: #5c5cf6ff;
    }

    &:active {
      transform: scale(0.95);
    }
  }

  .albums-carousel {
    overflow-x: auto;   
    overflow-y: hidden;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    
    /* Hide scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
      display: none;
    }
    
    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .albums-grid {
    display: flex;
    gap: 20px;
    padding-bottom: 10px;
    width: max-content;
  }

  .album-card {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: transform 0.3s ease;
    flex-shrink: 0;
    width: 230px;

    &:hover {
      transform: scale(1.03);
      
      .album-image-wrapper {
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);
      }
    }
  }

  .album-image-wrapper {
    width: 100%;
    aspect-ratio: 1;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 12px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
    transition: box-shadow 0.3s ease;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    position: relative;
  }

  .album-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .album-title {
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .album-artist {
    font-size: 14px;
    color: #b8b8b8;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .loading-container {
    height: 303px;
    padding: 40px 20px;
    text-align: center;
    color: #b8b8b8;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;

    p {
      margin: 0;
    }
  }

  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid rgba(255, 255, 255, 0.1);
    border-top: 3px solid #007AFE;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .no-playlists {
    padding: 40px 20px;
    text-align: center;
    color: #b8b8b8;
    font-size: 16px;

    p {
      margin: 0;
    }
  }

  /* Responsive Design */
  @media (max-width: 1400px) {
    .album-card {
      width: 220px;
    }
    
    .loading-container {
      height: 293.14px;
    }
  }

  @media (max-width: 1200px) {
    .hero-section,
    .best-albums-section {
      padding: 0 20px 0px 20px;
    }

    .album-card {
      width: 220px;
    }
  }

  @media (max-width: 768px) {
    .loading-container {
      height: 213.14px;
    }

    .hero-section {
      height: 300px;
      padding: 0 20px;
    }

    .hero-title {
      font-size: 22px;
    }

    .best-albums-section {
      padding: 0 0px 0px 20px;
    }

    .album-card {
      width: 140px;
    }

    .section-title {
      font-size: 22px;
    }

    .nav-button {
      width: 36px;
      height: 36px;
      font-size: 20px;
    }
  }
`;
